<div class="d-flex justify-content-center align-items-center vh-100">
    <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>
